import { Card } from "react-bootstrap";
import styled, { css } from "styled-components";

export const CardContainer = styled(Card)<{ $isUppercase?: boolean }>`
    font-family: Caladea, serif;
    font-size: ${({ theme }) => `${theme.font.size.h2}px`};
    border: none;
    text-align: center;

    & .card-body {
        margin: 50px 0;
        padding-left: 10%;
        padding-right: 10%;
        ${(props) =>
            props.$isUppercase &&
            css`
                text-transform: uppercase;
            `};

        ${({ theme: { breakpoints } }) => css`
            @media (max-width: ${breakpoints.mdMax}px) {
                font-size: ${({ theme }) => `${theme.font.size.h3}px`};
                margin: 20px 0;
            }

            @media (max-width: ${breakpoints.smMax}px) {
                font-size: ${({ theme }) => `${theme.font.size.h4}px`};
                margin: 20px 0;
            }
        `}
    }
`;
